<template>
  <div class="d-flex flex-nowrap justify-content-between">
    <h3>{{ title }}</h3>
    <div class="pull-right ml-1">
      <div class="d-flex">
        <slot></slot>

        <c-button-help
          v-if="helpDocId"
          :link="helpDocId"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    helpDocId: {
      type: String,
      default: ''
    }
  }
}
</script>
